module.exports = __webpack_public_path__ + "img/bottomLogo.7d81315a.png";